const INVOICE_TO_EDIT = "INVOICE_TO_EDIT";
const ORDER_INVOICES = "ORDER_INVOICES";
const INVOICE_SUB_STATUSES = "INVOICE_SUB_STATUSES";
const state = {
  invoiceToEdit: {},
  orderInvoices: {},
  subStatuses: [],
  isUpdating: false,
};

import api from "@/api";

const getters = {
  invoiceToEdit: state => state.invoiceToEdit,
  orderInvoices: state => state.orderInvoices,
  // subStatuses: state => state.subStatuses,
  subStatuses: (state) => {
    if (!state.isUpdating && !state.subStatuses.length) {
      getRecords();
    }
    return state.subStatuses;
  },
};

const getRecords = async () => {
  state.isUpdating = true;
  const {data} = await api.index('/onDemand/invoices/options/substatus');
  if (data.success) {
    state.subStatuses = data.records;
    state.isUpdating = false;
  }
};

const actions = {
  setInvoiceToEdit({dispatch, commit}, payload) {
    commit(INVOICE_TO_EDIT, payload);
  },
  setOrderInvoices({dispatch, commit}, payload) {
    commit(ORDER_INVOICES, payload);
  },
  async setSubStatuses({dispatch, commit}, payload) {
    commit(INVOICE_SUB_STATUSES, payload);
  },
};

const mutations = {
  [INVOICE_TO_EDIT](state, payload) {
    state.invoiceToEdit = payload;
  },
  [ORDER_INVOICES](state, payload) {
    state.orderInvoices = {...state.orderInvoices, ...payload};
  },
  [INVOICE_SUB_STATUSES](state, payload) {
    state.subStatuses = [...state.subStatuses];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
